import React from "react";
import type { ThemePattern as PatternName } from "../../types/courseTheme";
interface ThemePatternProps {
  id: string;
  pattern: PatternName;
  className?: string;
  style?: React.CSSProperties;
}

/** A full-bleed repeating tile drawn in currentColor. */
export function ThemePattern({
  id,
  pattern,
  className,
  style
}: ThemePatternProps) {
  return <svg className={className} style={style} aria-hidden="true" width="100%" height="100%" data-id="element-799" data-mp="3oop1xf31it7c">
      <defs data-id="element-800" data-mp="30z47o01fs9ir">
        <pattern id={id} width="56" height="56" patternUnits="userSpaceOnUse" data-id="element-801" data-mp="30yurf4671gq9">
          <g fill="none" stroke="currentColor" strokeWidth="1.2" data-id="element-802" data-mp="2wx974xrby061">
            {tiles[pattern]}
          </g>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} data-id="element-803" data-mp="35we3pyjbzjfk" />
    </svg>;
}
const petal = "M28 9 C33 15 33 21 28 26 C23 21 23 15 28 9 Z";
const tiles: Record<PatternName, React.ReactNode> = {
  azulejo: <>
      {[0, 90, 180, 270].map(r => <path key={r} d={petal} transform={`rotate(${r} 28 28)`} data-id="element-804" data-mp="l5nhps4qfvaf" />)}
      <path d="M28 25 L31 28 L28 31 L25 28 Z" data-id="element-805" data-mp="2hrej7ixnvqc9" />
      <path d="M0 8 A8 8 0 0 0 8 0 M48 0 A8 8 0 0 0 56 8 M56 48 A8 8 0 0 0 48 56 M8 56 A8 8 0 0 0 0 48" data-id="element-806" data-mp="2hukbt85i1acq" />
    </>,
  diamond: <>
      <path d="M28 6 L50 28 L28 50 L6 28 Z" data-id="element-807" data-mp="2rq3zj79wt2qe" />
      <path d="M28 26 v4 M26 28 h4" data-id="element-808" data-mp="2roas3prh2ehc" />
    </>,
  wave: <>
      <path d="M0 16 C9 9 19 9 28 16 C37 23 47 23 56 16" data-id="element-809" data-mp="2wo5na5ia5q87" />
      <path d="M0 44 C9 37 19 37 28 44 C37 51 47 51 56 44" data-id="element-810" data-mp="1z1yiovlz7xvu" />
    </>,
  dots: <>
      <circle cx="14" cy="14" r="1.3" fill="currentColor" stroke="none" data-id="element-811" data-mp="240szxt4apedu" />
      <circle cx="42" cy="42" r="1.3" fill="currentColor" stroke="none" data-id="element-812" data-mp="23yox7ei4ulf5" />
    </>
};